export default __webpack_public_path__ + "static/media/np.2d7d2bcb.svg";